import { createContext, useContext } from "react";

export const TranslationSwapVersionContext = createContext(0);

export const useTranslationSwapVersion = (): number => useContext(TranslationSwapVersionContext);
